import React from 'react';
import { Helmet } from 'react-helmet';

const Favicon = ({ favSrc }) => (
  <React.Fragment>
    <Helmet>
      <link rel="icon" href={favSrc} id="favicon" />
    </Helmet>
  </React.Fragment>
);

Favicon.propTypes = {
};

export default Favicon;



// WEBPACK FOOTER //
// ./src/containers/layout/favicon/Favicon.js